// Until exhaustive switch case checks are avaiable, using
// this with a default case will throw a type error
// https://github.com/typescript-eslint/typescript-eslint/issues/281
const unreachable = (v: never): never => v;

export default unreachable;
